import {
  REQUEST_WINTER_AREAS,
  RESPONSE_WINTER_AREAS,
  REQUEST_WINTER_AREAS_FAILURE,
  SET_WINTER_GROUPS_FILTER_ACTION,
  SET_WINTER_AREAS_FILTER_ACTION,
  REQUEST_WINTER_COMPANIES_ROUTES,
  RESPONSE_WINTER_COMPANIES_ROUTES,
  REQUEST_WINTER_COMPANIES_ROUTES_FAILURE,
  SET_WINTER_SENSORS_FILTER_ACTION,
  SET_WINTER_ROUTES_PERSENT,
  SET_WINTER_ROUTE_SMOTH_FACTOR,
  SET_OPEN_WINTER_COMPANIES_INFO,
  SEARCH_TERM_WINTER_UNIT,
  SET_WINTER_POUPUP,
  SET_ROUTE_OR_REPORT_MODE_ACTION,
  REQUEST_WINTER_REPORT_DOWNLOAD,
  RESPONSE_WINTER_REPORT_DOWNLOADT,
  REQUEST_WINTER_REPORT_DOWNLOAD_FAILURE,
  SET_GEOZONE_SEARCH,
  REQUEST_WINTER_EOSK_REPORT_DOWNLOAD,
  RESPONSE_WINTER_EOSK_REPORT_DOWNLOADT,
  REQUEST_WINTER_EOSK_REPORT_DOWNLOAD_FAILURE,
  REQUEST_WINTER_AREAS_SIMPLE,
  RESPONSE_WINTER_AREAS_SIMPLE,
  REQUEST_WINTER_AREAS_SIMPLE_FAILURE,
  REQUEST_WINTER_SHORT_EOSK_REPORT_DOWNLOAD,
  RESPONSE_WINTER_SHORT_EOSK_REPORT_DOWNLOADT,
  REQUEST_WINTER_SHORT_EOSK_REPORT_DOWNLOAD_FAILURE,
} from "../actions/winterMaintenceAction";

import { states } from "./queriesStates";
import booleanPointInPolygon from "@turf/boolean-point-in-polygon";

const initialState = {
  winterAreasDataState: states.NOT_REQUESTED,
  winterAreasSimpleDataState: states.NOT_REQUESTED,
  winterCompaniesRoutesDataState: states.NOT_REQUESTED,
  winterReportDownloadDataStrate: states.NOT_REQUESTED,
  winterEOSKReportDownloadDataStrate: states.NOT_REQUESTED,
  winterShortEOSKReportDownloadDataStrate: states.NOT_REQUESTED,
  timeCompaniesRoutesRequest: null,
  winterAreasGetData: new Date(),
  winterAreas: [],
  winterAreasSimple: [],
  winterGroups: [],
  winterWithoutGroupsFilter: true,
  winterGroupsFilter: [],
  winterAreasFilter: [],
  winterSensorsFilter: {
    viewRouteDump: true,
    viewRouteDump2: true,
    viewRouteSand: true,
    filterDump1: false,
    filterDump2: false,
    filterSand: false,
    dumpColor: "#000000",
    dump2Color: "#4368adff",
    sandColor: "#df8d21",
  },
  winterRouteUnitsProcess: 0,
  winterRouteSmoothFactor: 3,
  winterDashboard: null,
  openCompaniesInfoState: 0,
  searchTermWinterUnit: "",
  findUnitPosition: null,
  searchGeoZone: null,
  regionTitle: null,
  winterPoupup: { dataPoupup: null, positionPoupup: null },
  isReportMode: false,
  colorParentCompanies: {
    "729c9442-52f9-11ef-817b-0242ac110004": "#1abd95",
    "77be2302-39ed-11ef-9460-0242ac110004": "#2d569c",
    "77bcfbf8-39ed-11ef-9460-0242ac110004": "#318f28",
    "77bb1be4-39ed-11ef-9460-0242ac110004": "#5f2d9c",
  },
  errors: null,
};

const isParentCompanyView = (parentCompany, filterArea) => {
  return filterArea.parentCompanies.some((x) => {
    return x === parentCompany.id;
  });
};

const getFilterArea = (winterAreasFilter, area) => {
  return winterAreasFilter.filter((x) => {
    return x.winterAreaId === area.id;
  })[0];
};

const setSensorCount = (unit, winterDashboard, winterSensorsFilter, unitIsDataRoute, viewRoute) => {
  if (!viewRoute) {
    winterDashboard.sensors.dump.count += unit.isDumpSensor;
    winterDashboard.sensors.sand.count += unit.isSandSensor;
  }

  if (viewRoute) {
    winterDashboard.sensors.dump.count += unitIsDataRoute && unit.isDumpSensor;
    winterDashboard.sensors.sand.count += unitIsDataRoute && unit.isSandSensor;
  }

  if (winterSensorsFilter.viewRouteDump && unit.isDumpSensor) {
    if (unitIsDataRoute) {
      winterDashboard.sensors.dump.routeCount++;
      winterDashboard.sensors.dump.workCount += unit.dataRoute.distanceDump1 > 0;
      winterDashboard.sensors.dump.distance += unit.dataRoute.distanceDump1;
    }
  }

  if (winterSensorsFilter.viewRouteSand && unit.isSandSensor) {
    if (unitIsDataRoute) {
      winterDashboard.sensors.sand.routeCount++;
      winterDashboard.sensors.sand.workCount += unit.dataRoute.distanceSand > 0;
      winterDashboard.sensors.sand.distance += unit.dataRoute.distanceSand;
    }
  }
};

const getWinterDashboard = (
  winterAreas,
  winterGroups,
  winterAreasFilter,
  winterWithoutGroupsFilter,
  winterGroupsFilter,
  winterSensorsFilter,
  searchGeoZone,
  viewRoute = false
) => {
  const winterDashboard = {
    winterGroups: {
      whithOut: { count: 0, totalCount: 0, noDataCount: 0 },
      groups: [],
    },
    sensors: {
      dump: { count: 0, routeCount: 0, workCount: 0, totalCount: 0, distance: 0 },
      sand: { count: 0, routeCount: 0, workCount: 0, totalCount: 0, distance: 0 },
    },
    areas: [],
    unitPositions: [],
  };

  winterDashboard.winterGroups.groups = winterGroups.map((group) => {
    return { id: group.id, count: 0, totalCount: 0 };
  });

  winterAreas.forEach((area) => {
    const _area = {
      id: area.id,
      parentCompanies: area.parentCompanies.map((parentCompany) => {
        return {
          id: parentCompany.id,
          count: 0,
          totalCount: 0,
          unitViewCount: 0,
        };
      }),
    };

    winterDashboard.areas.push(_area);
  });

  winterAreas.forEach((area, areaIndex) => {
    const filterArea = getFilterArea(winterAreasFilter, area);
    const areaDashboard = winterDashboard.areas[areaIndex];
    const searchPolygon = searchGeoZone !== null ? JSON.parse(searchGeoZone) : searchGeoZone;

    area.parentCompanies.forEach((parentCompany, parentIndex) => {
      if (!isParentCompanyView(parentCompany, filterArea)) {
        return;
      }

      parentCompany.companies.forEach((company) => {
        /*    if (filterArea.regionId !== null && company.region.id !== filterArea.regionId) {
          return;
        } */

        if (filterArea.companyId !== null && company.id !== filterArea.companyId) {
          return;
        }

        const parenCompanyDashboard = areaDashboard.parentCompanies[parentIndex];

        company.units.forEach((unit) => {
          unit.isView = unit.lastPosition !== null;

          winterDashboard.sensors.dump.totalCount += unit.isDumpSensor;
          winterDashboard.sensors.sand.totalCount += unit.isSandSensor;

          const unitIsDataRoute = !!unit.dataRoute && unit.dataRoute.distance !== 0 && unit.dataRoute.route.length > 0;

          if (!unitIsDataRoute && !!unit.dataRoute && unit.dataRoute.distance !== 0) {
            unit.dataRoute.distance = 0;
            unit.dataRoute.distanceDump1 = 0;
            unit.dataRoute.distanceDump2 = 0;
            unit.dataRoute.distanceSand = 0;
          }

          if (viewRoute && !!unit.dataRoute && unit.dataRoute.distance !== 0 && unit.dataRoute.route.length > 0) {
            const i = unit.dataRoute.route.length - 1;
            const j = unit.dataRoute.route[i].length - 1;
            const k = unit.dataRoute.route[i][j].length - 1;

            winterDashboard.unitPositions.push({
              id: unit.id,
              registerNumber: unit.registerNumber,
              position: unit.dataRoute.route[i][j][k],
            });
          } else if (!viewRoute && unit.lastPosition != null) {
            const point = {
              type: "Point",
              coordinates: [parseFloat(unit.lastPosition.data["COOX"]), parseFloat(unit.lastPosition.data["COOY"])],
            };

            unit.isView = searchPolygon === null || booleanPointInPolygon(point, searchPolygon);

            if (unit.isView) {
              winterDashboard.unitPositions.push({
                id: unit.id,
                registerNumber: unit.registerNumber,
                position: point,
              });
            }
          }

          if (unit.isView && winterSensorsFilter.filterDump1 && !unit.isDumpSensor) {
            unit.isView = false;
          }

          if (unit.isView && winterSensorsFilter.filterDump2 && !unit.isDumpSensor2) {
            unit.isView = false;
          }

          if (unit.isView && winterSensorsFilter.filterSand && !unit.isSandSensor) {
            unit.isView = false;
          }

          let viewSensor = unit.isView;
          parenCompanyDashboard.totalCount++;

          if (!viewRoute) parenCompanyDashboard.count += unitIsDataRoute || unit.isView ? 1 : 0;
          if (viewRoute) parenCompanyDashboard.count += unitIsDataRoute && unit.isView ? 1 : 0;

          if (unit.groups.length === 0) {
            winterDashboard.winterGroups.whithOut.totalCount += winterWithoutGroupsFilter;
            winterDashboard.winterGroups.whithOut.count += winterWithoutGroupsFilter && (unitIsDataRoute || unit.isView);
          } else {
            winterDashboard.winterGroups.groups.forEach((group) => {
              const groupToolsIsChecked = winterGroupsFilter.some((x) => {
                return x === group.id;
              });

              if (groupToolsIsChecked) {
                const inGroups = unit.groups.some((x) => {
                  return x.id === group.id;
                });

                group.totalCount += inGroups;

                if (inGroups && unit.isView) {
                  group.count += unitIsDataRoute || unit.isView;
                  viewSensor = true;
                }
              }
            });
          }

          if (viewSensor && unit.isView) {
            setSensorCount(unit, winterDashboard, winterSensorsFilter, unitIsDataRoute, viewRoute);
          }

          parenCompanyDashboard.unitViewCount += unit.isView;
        });

        areaDashboard.parentCompanies[parentIndex] = parenCompanyDashboard;
      });
    });

    winterDashboard.areas[areaIndex] = areaDashboard;
  });

  return winterDashboard;
};

const winterMaintenceReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_WINTER_AREAS_SIMPLE:
      return Object.assign({}, state, {
        winterAreasSimpleDataState: states.REQUEST,
      });

    case RESPONSE_WINTER_AREAS_SIMPLE:
      return Object.assign({}, state, {
        winterAreasSimpleDataState: states.READY,
        winterAreasSimple: action.data.areas,
      });

    case REQUEST_WINTER_AREAS_SIMPLE_FAILURE:
      return Object.assign({}, state, {
        winterAreasSimpleDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_WINTER_AREAS:
      return Object.assign({}, state, {
        winterAreasDataState: states.REQUEST,
        winterAreasGetData: new Date(),
      });

    case RESPONSE_WINTER_AREAS:
      if (state.winterCompaniesRoutesDataState !== states.NOT_REQUESTED) {
        return state;
      }

      const _winterGroupsFilter =
        state.winterAreas.length === 0
          ? action.data.groups.map((x) => {
              return x.id;
            })
          : state.winterGroupsFilter;

      const _winterAreasFilter =
        state.winterAreas.length === 0
          ? action.data.areas.map((x) => {
              return {
                winterAreaId: x.id,
                regionId: null,
                companyId: null,
                parentCompanies: x.parentCompanies.map((p) => {
                  return p.id;
                }),
              };
            })
          : state.winterAreasFilter;

      return Object.assign({}, state, {
        winterAreasDataState: states.READY,
        winterAreas: action.data.areas,
        winterAreasGetData: new Date(),
        winterGroups: action.data.groups,
        winterGroupsFilter: _winterGroupsFilter,
        winterAreasFilter: _winterAreasFilter,
        winterDashboard: getWinterDashboard(
          action.data.areas,
          action.data.groups,
          _winterAreasFilter,
          state.winterWithoutGroupsFilter,
          _winterGroupsFilter,
          state.winterSensorsFilter,
          state.searchGeoZone,
          state.winterCompaniesRoutesDataState !== states.NOT_REQUESTED
        ),
      });

    case REQUEST_WINTER_AREAS_FAILURE:
      return Object.assign({}, state, {
        winterAreasDataState: states.FAILURE,
        errors: action.errors,
      });

    case SET_WINTER_GROUPS_FILTER_ACTION:
      const _state = Object.assign({}, state, {
        winterWithoutGroupsFilter: action.winterWithoutGroupsFilter,
        winterGroupsFilter: action.winterGroupsFilter,
        winterPoupup: { dataPoupup: null, positionPoupup: null },
      });

      return Object.assign({}, _state, {
        winterDashboard: getWinterDashboard(
          state.winterAreas,
          state.winterGroups,
          state.winterAreasFilter,
          action.winterWithoutGroupsFilter,
          action.winterGroupsFilter,
          state.winterSensorsFilter,
          state.searchGeoZone,
          state.winterCompaniesRoutesDataState !== states.NOT_REQUESTED
        ),
      });

    case SET_WINTER_AREAS_FILTER_ACTION:
      const __state = Object.assign({}, state, {
        winterAreasFilter: action.winterAreasFilter,
        winterPoupup: { dataPoupup: null, positionPoupup: null },
      });

      return Object.assign({}, __state, {
        winterDashboard: getWinterDashboard(
          state.winterAreas,
          state.winterGroups,
          action.winterAreasFilter,
          state.winterWithoutGroupsFilter,
          state.winterGroupsFilter,
          state.winterSensorsFilter,
          state.searchGeoZone,
          state.winterCompaniesRoutesDataState !== states.NOT_REQUESTED
        ),
      });

    case SET_WINTER_SENSORS_FILTER_ACTION:
      return Object.assign({}, state, {
        winterSensorsFilter: action.winterSensorsFilter,
        winterPoupup: { dataPoupup: null, positionPoupup: null },
        winterDashboard: getWinterDashboard(
          state.winterAreas,
          state.winterGroups,
          state.winterAreasFilter,
          state.winterWithoutGroupsFilter,
          state.winterGroupsFilter,
          action.winterSensorsFilter,
          state.searchGeoZone,
          state.winterCompaniesRoutesDataState !== states.NOT_REQUESTED
        ),
      });

    case REQUEST_WINTER_COMPANIES_ROUTES:
      const _winterAreas = state.winterAreas.map((area) => {
        area.parentCompanies.forEach((parentCompany) => {
          parentCompany.companies.forEach((company) => {
            company.units.forEach((unit) => {
              unit.dataRoute = null;
            });
          });
        });

        return area;
      });

      return Object.assign({}, state, {
        winterCompaniesRoutesDataState: states.REQUEST,
        winterAreas: _winterAreas,
        winterPoupup: { dataPoupup: null, positionPoupup: null },
        winterRouteUnitsProcess: 0,
        timeCompaniesRoutesRequest: new Date(),
      });

    case RESPONSE_WINTER_COMPANIES_ROUTES:
      const __winterAreas = state.winterAreas.map((area) => {
        const dataForArea = action.data.filter((x) => {
          return x.winterAreaId === area.id;
        });

        area.parentCompanies.forEach((parentCompany) => {
          const dataForParentCompany = dataForArea.filter((x) => {
            return x.winterParentCompanyId === parentCompany.id;
          });

          parentCompany.companies.forEach((company) => {
            const dataForCompany = dataForParentCompany.filter((x) => {
              return x.winterCompanyId === company.id;
            })[0];

            company.units.forEach((unit) => {
              unit.dataRoute = null;

              if (dataForCompany !== undefined && dataForCompany.units !== undefined) {
                unit.dataRoute = dataForCompany.units.filter((x) => {
                  return x.id === unit.id;
                })[0];
              }
            });
          });
        });

        return area;
      });

      return Object.assign({}, state, {
        winterCompaniesRoutesDataState: states.READY,
        winterAreas: __winterAreas,

        winterDashboard: getWinterDashboard(
          __winterAreas,
          state.winterGroups,
          state.winterAreasFilter,
          state.winterWithoutGroupsFilter,
          state.winterGroupsFilter,
          state.winterSensorsFilter,
          state.searchGeoZone,
          true
        ),
      });

    case REQUEST_WINTER_COMPANIES_ROUTES_FAILURE:
      return Object.assign({}, state, {
        winterCompaniesRoutesDataState: states.FAILURE,
        errors: action.errors,
      });

    case SET_WINTER_ROUTES_PERSENT:
      return Object.assign({}, state, {
        winterRouteUnitsProcess: action.data,
      });

    case SET_WINTER_ROUTE_SMOTH_FACTOR:
      return Object.assign({}, state, {
        winterRouteSmoothFactor: action.winterRouteSmoothFactor,
        winterPoupup: { dataPoupup: null, positionPoupup: null },
      });

    case SET_OPEN_WINTER_COMPANIES_INFO:
      return Object.assign({}, state, {
        openCompaniesInfoState: action.openCompaniesInfoState,
        winterPoupup: { dataPoupup: null, positionPoupup: null },
      });

    case SEARCH_TERM_WINTER_UNIT:
      const unit = state.winterDashboard.unitPositions.filter((x) => {
        return action.searchTerm.length > 3 && x.registerNumber.toLowerCase().includes(action.searchTerm.toLowerCase());
      })[0];

      return Object.assign({}, state, {
        searchTermWinterUnit: action.searchTerm.toLowerCase(),
        findUnitPosition: unit !== undefined ? unit.position : null,
        winterPoupup: { dataPoupup: null, positionPoupup: null },
      });

    case SET_WINTER_POUPUP:
      return Object.assign({}, state, {
        winterPoupup: action.data,
      });

    case SET_ROUTE_OR_REPORT_MODE_ACTION:
      return Object.assign({}, state, {
        isReportMode: action.data,
      });

    case REQUEST_WINTER_REPORT_DOWNLOAD:
      return Object.assign({}, state, {
        winterReportDownloadDataStrate: states.REQUEST,
      });

    case RESPONSE_WINTER_REPORT_DOWNLOADT:
      return Object.assign({}, state, {
        winterReportDownloadDataStrate: states.READY,
      });

    case REQUEST_WINTER_REPORT_DOWNLOAD_FAILURE:
      return Object.assign({}, state, {
        winterReportDownloadDataStrate: states.FAILURE,
      });

    case SET_GEOZONE_SEARCH:
      return Object.assign({}, state, {
        searchGeoZone: action.data,
        regionTitle: action.regionTitle,
      });

    case REQUEST_WINTER_EOSK_REPORT_DOWNLOAD:
      return Object.assign({}, state, {
        winterEOSKReportDownloadDataStrate: states.REQUEST,
      });

    case RESPONSE_WINTER_EOSK_REPORT_DOWNLOADT:
      return Object.assign({}, state, {
        winterEOSKReportDownloadDataStrate: states.READY,
      });

    case REQUEST_WINTER_EOSK_REPORT_DOWNLOAD_FAILURE /*  */:
      return Object.assign({}, state, {
        winterEOSKReportDownloadDataStrate: states.FAILURE,
      });

    case REQUEST_WINTER_SHORT_EOSK_REPORT_DOWNLOAD:
      return Object.assign({}, state, {
        winterShortEOSKReportDownloadDataStrate: states.REQUEST,
      });

    case RESPONSE_WINTER_SHORT_EOSK_REPORT_DOWNLOADT:
      return Object.assign({}, state, {
        winterShortEOSKReportDownloadDataStrate: states.READY,
      });

    case REQUEST_WINTER_SHORT_EOSK_REPORT_DOWNLOAD_FAILURE:
      return Object.assign({}, state, {
        winterShortEOSKReportDownloadDataStrate: states.FAILURE,
      });

    default:
      return state;
  }
};

export default winterMaintenceReducer;
